module.exports = __webpack_public_path__ + "static/techladies-02c5752b6f2f22b9308f679a33da2352.png";